// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { apiClient } from './client'
import type { User, AuthTokens, WorkspaceSummary } from '@/types'

export const authExtraApi = {
  getWorkspaces: () => apiClient.get<{ workspaces: WorkspaceSummary[] }>('/v1/auth/workspaces'),

  switchWorkspace: (tenantId: string) =>
    apiClient.post<{ tokens: AuthTokens; user: User }>('/v1/auth/workspaces/switch', { tenantId }),
}
